import PropTypes from "prop-types";

export default {
  allowTracking: PropTypes.bool,
  analyticsId: PropTypes.string,
  canDebug: PropTypes.bool,
  email: PropTypes.string,
  id: PropTypes.number,
  token: PropTypes.string,
  userTypeId: PropTypes.number,
};
